
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mumbaicentraltopunecab() {



    const cardData =
    {
        keyword: 'Mumbai Central to Pune Cab',
        heading: 'Skyline Cabs: Mumbai Central to Pune Cab ',
        headingDescription: 'Skyline Cabs offers reliable and efficient Mumbai Central to Pune Cab services for a smooth and timely intercity journey. Whether you are traveling for business, leisure, or catching a flight, our professional drivers and clean, well-maintained vehicles ensure a safe and comfortable ride. With on-time pickups from Mumbai Central, transparent fares, and 24/7 customer support, Skyline Cabs makes your travel to Pune stress-free. Book your Mumbai Central to Pune cab today for a comfortable and convenient experience.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
    {
      "name": "Mumbai Central to Pune Taxi",
      "description": "Skyline Cabs offers reliable taxi services from Mumbai Central to Pune with flexible pickup options and a wide range of vehicles. Whether you're heading for business or leisure, enjoy a safe, clean, and timely ride with professional drivers."
    },
    {
      "name": "Taxi from Mumbai Central to Pune",
      "description": "Book a taxi from Mumbai Central to Pune with Skyline Cabs for a smooth intercity travel experience. Choose from sedans, Ertiga, or Innova Crysta, all equipped with AC and GPS tracking for your comfort and safety."
    },
    {
      "name": "Taxi from Mumbai Central to Pune One Way Cab",
      "description": "Looking for a one-way cab from Mumbai Central to Pune? Skyline Cabs offers affordable and efficient one-way taxi services with no return charges. Ideal for travelers needing a quick and convenient drop."
    },
    {
      "name": "Mumbai Central to Pune Drop Taxi",
      "description": "Skyline Cabs provides drop taxi services from Mumbai Central to Pune. Book a comfortable ride at competitive rates, perfect for airport transfers, weekend getaways, or business travel."
    },
    {
      "name": "Mumbai Central to Baner Taxi",
      "description": "Travel from Mumbai Central to Baner, Pune with Skyline Cabs. Our clean, air-conditioned taxis and courteous drivers ensure you reach your destination comfortably and on time."
    },
    {
      "name": "Mumbai Central to Pune Innova Taxi",
      "description": "Hire a premium Innova from Mumbai Central to Pune for group travel or added space. Our Innova Crysta offers comfort, reliability, and safety for long-distance travel."
    },
    {
      "name": "Mumbai Central to Pune Ertiga Taxi",
      "description": "For families or small groups, Skyline Cabs offers Ertiga cabs from Mumbai Central to Pune. Enjoy spacious seating, smooth rides, and budget-friendly rates for outstation travel."
    },
    {
      "name": "Mumbai Central to Pune Sedan Taxi",
      "description": "Book a sedan like Swift Dzire or Etios from Mumbai Central to Pune with Skyline Cabs. Perfect for solo travelers or small families looking for a comfortable, affordable ride."
    },
    {
      "name": "Mumbai Central to Pune Swift Dzire Taxi",
      "description": "Skyline Cabs provides Swift Dzire cabs from Mumbai Central to Pune for a reliable, fuel-efficient, and affordable travel solution. Perfect for daily commutes or short business trips."
    },
    {
      "name": "Mumbai Central to Pune Cab",
      "description": "Skyline Cabs offers cab booking from Mumbai Central to Pune with various options—one-way, round-trip, hourly packages, and more. Clean cars, courteous drivers, and 24/7 support."
    },
    {
      "name": "Pune to Mumbai Central Cab",
      "description": "Need to return to Mumbai Central from Pune? Skyline Cabs offers one-way or round-trip services with real-time updates, professional drivers, and transparent fares."
    },
    {
      "name": "Pune to Mumbai Central Taxi",
      "description": "Get a taxi from Pune to Mumbai Central with Skyline Cabs. Our services include door-to-door pickup, safe and sanitized vehicles, and competitive fares."
    },
    {
      "name": "Cab Service in Mumbai Central",
      "description": "Skyline Cabs is your go-to provider for taxi and cab services in Mumbai Central. We offer airport drops, intercity rides, and hourly rental packages for corporate or personal use."
    },
    {
      "name": "Cheapest Cab Service in Mumbai",
      "description": "Looking for affordable cabs in Mumbai? Skyline Cabs provides the best rates without compromising on safety or service quality. Choose from a range of vehicles and payment options."
    },
    {
      "name": "Best Cab Service in Mumbai",
      "description": "Skyline Cabs is recognized for delivering top-tier taxi services across Mumbai. Whether you need a cab to Pune, airport transfer, or a local ride, count on us for punctuality, cleanliness, and professional drivers."
    },
    {
      "name": "Mumbai to Pune Cab Booking",
      "description": "Book your Mumbai to Pune cab with Skyline Cabs online or over the phone. Our process is simple and transparent, with no hidden charges and 24/7 customer support."
    },
    {
      "name": "Mumbai Central Cab Service",
      "description": "Skyline Cabs provides full-range cab services from Mumbai Central—ideal for business trips, Pune transfers, or outstation travel. Choose sedans, Ertiga, or Innova as per your travel needs."
    },
    {
      "name": "Best Outstation Cab Service in Mumbai",
      "description": "Skyline Cabs is a trusted name for outstation cab services in Mumbai. With professional drivers, clean cars, and competitive pricing, we ensure your long-distance travel is smooth and worry-free."
    }
  ],
  "tableData": [
    ["Mumbai Central to Pune Taxi", "Taxi from Mumbai Central to Pune"],
    ["Taxi from Mumbai Central to Pune One Way Cab", "Mumbai Central to Pune Drop Taxi"],
    ["Mumbai Central to Baner Taxi", "Mumbai Central to Pune Innova Taxi"],
    ["Mumbai Central to Pune Ertiga Taxi", "Mumbai Central to Pune Sedan Taxi"],
    ["Mumbai Central to Pune Swift Dzire Taxi", "Mumbai Central to Pune Cab"],
    ["Pune to Mumbai Central Cab", "Pune to Mumbai Central Taxi"],
    ["Cab Service in Mumbai Central", "Cheapest Cab Service in Mumbai"],
    ["Best Cab Service in Mumbai", "Mumbai to Pune Cab Booking"],
    ["Mumbai Central Cab Service", "Best Outstation Cab Service in Mumbai"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Dependable Mumbai Central to Pune Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers reliable and hassle-free cab service from Mumbai Central to Pune. Whether you're catching a meeting, heading home, or planning a weekend escape, our punctual pickups and smooth rides make your intercity travel stress-free and convenient."
    },
    {
        "WhyChooseheading": "Comfortable, Clean, and Spacious Vehicles",
        "WhyChoosedescription": "Enjoy maximum comfort with our fleet of air-conditioned, well-maintained vehicles. Our cabs—from sedans to SUVs—are spacious, regularly sanitized, and equipped with all the essentials to ensure a relaxing trip from Mumbai Central to Pune."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our courteous drivers are trained for long-distance routes and well-acquainted with the best paths from Mumbai Central to Pune. They prioritize your safety, drive responsibly, and ensure you reach your destination comfortably and on time."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "With Skyline Cabs, you pay only for what you use—no hidden charges, no surprise fees. Our fare structure is clear, competitive, and designed to offer premium service at the right price. One-way and round-trip options are both available at budget-friendly rates."
    },
    {
        "WhyChooseheading": "24/7 Cab Service from Mumbai Central",
        "WhyChoosedescription": "Whether you're traveling early in the morning or late at night, Skyline Cabs operates 24/7. You can book your cab from Mumbai Central to Pune anytime, and we’ll be there—punctual, professional, and ready to go."
    },
    {
        "WhyChooseheading": "Cab Options for Every Traveler",
        "WhyChoosedescription": "Traveling solo or with a group? We’ve got you covered. Choose from fuel-efficient sedans, roomy SUVs, or luxurious cars depending on your needs. Each vehicle is designed to deliver comfort, safety, and a pleasant ride over long distances."
    },
    {
        "WhyChooseheading": "Fast Booking with Real-Time Ride Tracking",
        "WhyChoosedescription": "Book your ride from Mumbai Central to Pune in just a few clicks through our website or app. Enjoy instant confirmation, live driver tracking, and seamless digital payments—making your experience smooth from booking to drop-off."
    },
    {
        "WhyChooseheading": "Safe and Secure Ride Every Time",
        "WhyChoosedescription": "Your safety is our top priority. All Skyline Cabs are GPS-enabled, sanitized, and driven by background-verified professionals. Whether you're traveling day or night, you can trust us for a secure and dependable ride from Mumbai Central to Pune."
    }
]



















    }


    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Mumbai Central to Pune with Skyline Cabs?',
            answer:
                'Booking with Skyline Cabs is quick and easy. Visit our website or use our mobile app, select Mumbai Central as your pickup point and Pune as the drop-off location, then choose your preferred vehicle and confirm.',
        },
        {
            id: 2,
            question: 'What types of cabs are available for the Mumbai Central to Pune route?',
            answer:
                'Skyline Cabs offers a wide range of vehicles including Sedans, SUVs, Ertiga, Innova Crysta, and luxury cars. You can select a car based on your group size and comfort level.',
        },
        {
            id: 3,
            question: 'Are fares from Mumbai Central to Pune fixed?',
            answer:
                'Yes, we offer fixed and transparent pricing that includes tolls, taxes, and driver charges. There are no hidden costs — what you see is what you pay.',
        },
        {
            id: 4,
            question: 'Do you provide pickup from Mumbai Central Railway Station?',
            answer:
                'Absolutely! We provide prompt pickups from Mumbai Central Railway Station. Share your train arrival time, and we’ll ensure a driver is waiting for you.',
        },
        {
            id: 5,
            question: 'How long does the journey from Mumbai Central to Pune take?',
            answer:
                'The trip usually takes around 3.5 to 4.5 hours depending on the time of day and traffic conditions. Our drivers are trained to take the fastest and safest routes.',
        },
        {
            id: 6,
            question: 'Can I book a one-way or round-trip cab?',
            answer:
                'Yes, you can choose either. We offer one-way as well as round-trip services from Mumbai Central to Pune with flexible scheduling.',
        },
        {
            id: 7,
            question: 'Are your cabs available 24/7 from Mumbai Central?',
            answer:
                'Yes, Skyline Cabs operates 24/7. Whether your train arrives early morning or late night, we’ll be there for a smooth pickup.',
        },
        {
            id: 8,
            question: 'Do your drivers follow safety protocols?',
            answer:
                'Definitely. All drivers are background-verified, trained, and strictly follow safety and hygiene protocols to ensure your trip is safe and stress-free.',
        },
        {
            id: 9,
            question: 'Can I cancel or reschedule my Mumbai Central to Pune cab?',
            answer:
                'Yes, Skyline Cabs provides flexible cancellation and rescheduling options. You can manage your booking through our app, website, or customer support.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs from Mumbai Central to Pune?',
            answer:
                'Skyline Cabs stands for reliability, clean and comfortable cars, trained drivers, and transparent fares. We ensure a smooth and relaxing ride from the heart of Mumbai to Pune.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Arvind Shelar",
            rating: 5,
            review: "Booked a cab from Mumbai Central Station to Pune and the experience was excellent. The driver arrived on time, helped with my luggage, and the drive was calm and smooth. Highly recommend Skyline Cabs for intercity travel!"
        },
        {
            name: "Miss. Neha Patil",
            rating: 4,
            review: "I traveled solo from Mumbai Central to Pune with Skyline Cabs. The driver was professional and the car was super clean. Just wished there was a quick refreshment stop, but overall, a great ride!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Central to Pune Cabs",
  "image": "https://skylinecabs.com/assets/images/mumbai-central-to-pune-cab.jpg",
  "description": "Book Mumbai Central to Pune cabs with Skyline Cabs for a smooth and affordable journey. Enjoy 24/7 AC cab service with experienced drivers, perfect for both one-way and round-trip travel.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7486"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1300",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-central-to-pune-cabs"
  }
};



      
     
      


    return (
        <div>

<Helmet>
  <title>Mumbai Central to Pune Cabs | 24x7 AC Taxi Booking | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai Central to Pune cabs with Skyline Cabs for a smooth and affordable journey. Enjoy 24/7 AC cab service with experienced drivers, perfect for both one-way and round-trip travel." 
  />
  <meta 
    name="keywords" 
    content="Mumbai Central to Pune Cabs, Cab from Mumbai Central to Pune, One-Way Taxi Mumbai Central to Pune, Round Trip Cab Mumbai Central to Pune, AC Cab Mumbai Central to Pune, SUV Taxi Mumbai Central to Pune, 24/7 Cabs Mumbai Central to Pune, Skyline Cabs Mumbai Central to Pune, Online Cab Booking Mumbai Central Pune, Affordable Taxi Mumbai Central to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/36.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaicentraltopunecab;